import React, {useContext} from 'react';
import logo from "../../img/logo.png";
import {Button} from "primereact/button";
import { useTranslation } from 'react-i18next';
import LanguageSelector from "../../Shared/LanguageSelector";
import {KeycloakContext} from "../../context/KeycloakContext";
import Logo from "../../Shared/Logo"

// Definición de un componente funcional
const NoAccess = ({ logout }) => {
    const { kc , appInsights, theme } = useContext( KeycloakContext )

    const { t } = useTranslation();

    return (
        <div className="mimetika-login container mx-auto min-h-screen flex justify-content-center align-items-center">
            <div>
                <LanguageSelector appInsights={appInsights}/>
                <div className="mb-2 mt-2 sm:mt-32 md:mt-0 lg:mt-0 text-6xl text-center font-light text-gray">
                    {t('NoLicense')}
                </div>
                <Button onClick={logout} label={t('Logout')} className="logout-button min-w-40 " />
                
                  
            </div>
        </div>
    );
}

export default NoAccess;
